import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { InformationLoadingComponent } from "@/Common/Components/Loader/InformationLoadingComponent";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";
import { GetAccountActivityResponse } from "@/Common/Models/Portal/ActivityLog/GetAccountActivityResponse";
import { RecentActivityDto } from "@/Common/Models/Portal/ActivityLog/RecentActivityDto";
import * as ServerOperations from "@/Common/Operations/operations.server";

import "./AccountRecentActivity.css";

interface IAccountRecentActivity {
    patientContactId: string;
}

class AccountRecentActivityState {
    public isLoading: boolean;
    public isError: boolean;
    public recentActivity: RecentActivityDto[] = [];
}

class AccountRecentActivity extends React.Component<IAccountRecentActivity, AccountRecentActivityState> {
    constructor(props: IAccountRecentActivity) {
        super(props);

        this.state = {
            isLoading: false,
            isError: false,
            recentActivity: []
        };
    }

    public componentDidMount(): void {
        this.loadRecentActivity();
    }

    public componentDidUpdate(prevProps: IAccountRecentActivity): void {
        if (this.props.patientContactId !== prevProps.patientContactId) {
            this.loadRecentActivity();
        }
    }

    public render(): JSX.Element {
        let displayMessage: JSX.Element = null;
        let displayList: JSX.Element[] = null;

        if (this.state.isLoading) {
            displayMessage = <InformationLoadingComponent smallVersion={true} customMessage={cacheStore.GetString("WaitForPortalLabel")} />;
        }
        else if (this.state.isError) {
            displayMessage = <div className="portal-activity">{cacheStore.GetString("InternalServerError")}</div>;
        }
        else if (this.state.recentActivity && this.state.recentActivity.length) {
            displayList = this.state.recentActivity.map((a, idx) => (
                <div key={"activity" + idx} className="portal-activity">
                    {cacheStore.ClinicSettings.EnablePortalInvitationFlowV2
                        ?
                        (<div style={{ fontWeight: "bold" }}>{LuxonDateHelper.formatToFullDateTime(a.ActivityDate)}</div>)
                        :
                        (<div style={{ fontWeight: "bold" }}>{moment.utc(a.ActivityDate).local().format("YYYY-MM-DD [@]HH:mm:ss A")}</div>)
                    }
                    <div>{a.Description}</div>
                </div>
            ));
        }
        else {
            displayMessage = <div className="portal-activity">{cacheStore.GetString("NoRecentActivityLabel")}</div>;
        }

        return (
            <div className="accountRecentActivity">
                <div className="block separated max-height">
                    <div className="flex-container heading">
                        <h3 className="thin-font"> {cacheStore.GetString("RecentActivityLabel")}</h3>
                    </div>
                    <div className="centered">
                        {!displayList && displayMessage}
                        {displayList}
                    </div>
                </div>
            </div>
        );
    }

    private loadRecentActivity(): void {
        let self = this;
        let requestData = {
            PatientId: this.props.patientContactId
        };

        new Client()
            .Post(
                apiSettings.buildApiPath(),
                ServerOperations.Server.Portal_Proxy_GetRecentActivity,
                requestData,
                response => self.onFetchSuccess(response),
                () => self.onError()
            );

        let s = new AccountRecentActivityState();
        s.isLoading = true;
        this.setState(s);
    }

    private onFetchSuccess(response: GetAccountActivityResponse): void {
        let s = new AccountRecentActivityState();

        if (response.Errors && response.Errors.length) {
            s.isError = true;
        }
        else {
            s.recentActivity = response.RecentActivity;
        }

        s.isLoading = false;
        this.setState(s);
    }

    private onError(): void {
        var s = new AccountRecentActivityState();
        s.isError = true;
        s.isLoading = false;
        this.setState(s);
    }
}

export { AccountRecentActivity };
